/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const WrapTextIcon = /*#__PURE__*/ createSvgIcon(
  'WrapTextIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            stroke="currentColor"
            strokeMiterlimit={10}
          >
            <path d="M0 .41h20M0 19.59h20M13.22 14.79H20M13.22 5.21H20M13.22 10H20M10.3 5.14H.65v9.65h9.65V5.14z" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default WrapTextIcon;
